import { NewbieTaskName } from '@/app/constants';
import type { FreeCreditsTask } from '@/app/types';

const MANUAL_CLAIM_NEWBIE_TASKS = new Set<string>([
  NewbieTaskName.newbie_task_i2v_Q2_credit,
  NewbieTaskName.newbie_task_c2v_Q2_credit,
  NewbieTaskName.newbie_task_use_material_credit,
  NewbieTaskName.newbie_task_image_to_video_credit,
]);

/** 待领取任务完成时展示领取入口，积分到账提示只由领取接口成功后展示。 */
export const isManualClaimNewbieTask = (taskName: string): boolean => MANUAL_CLAIM_NEWBIE_TASKS.has(taskName);

/** 提交接口未返回 matched_nexus_set 时，用刷新前后的父任务状态变化兜底识别待领取任务。 */
export const hasNewlyClaimableAdvancedTask = (
  previousTasks: FreeCreditsTask[],
  currentTasks: FreeCreditsTask[],
): boolean => {
  const previousPendingTaskNames = new Set(
    previousTasks.filter((task) => task.state === 'pending_claim').map((task) => task.name),
  );
  return currentTasks.some((task) => task.state === 'pending_claim' && !previousPendingTaskNames.has(task.name));
};
